
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Auto-entrepreneurs : quelles bonnes résolutions prendre en 2026 ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "En ce début d’année, quelles bonnes résolutions prendre pour développer votre activité et réussir les 12 prochains mois ? Cet article vous en propose 5 !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Auto-entrepreneurs : quelles bonnes résolutions prendre en 2026 ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "En ce début d’année, quelles bonnes résolutions prendre pour développer votre activité et réussir les 12 prochains mois ? Cet article vous en propose 5 !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
